<div class="border border-yellow-700 rounded-xl p-6 bg-black shadow-lg my-6" [formGroup]="countryFilterForm">
  <h2 class="text-xl text-yellow-400 font-bold mb-6 border-b border-yellow-700 pb-2">
    🔍 Filter Countries
  </h2>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <!-- Country Name -->
    <div>
      <label for="name" class="block mb-1 text-sm font-semibold text-yellow-300">Country Name</label>
      <input
        id="name"
        formControlName="name"
        type="text"
        placeholder="Enter country name"
        class="w-full rounded-lg bg-gray-900 text-yellow-200 placeholder-yellow-500 border border-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-yellow-500 px-4 py-2 shadow-inner transition duration-300"
      />
    </div>

    <!-- Country Code -->
    <div>
      <label for="code" class="block mb-1 text-sm font-semibold text-yellow-300">Country Code</label>
      <input
        id="code"
        formControlName="code"
        type="text"
        placeholder="Enter country code"
        class="w-full rounded-lg bg-gray-900 text-yellow-200 placeholder-yellow-500 border border-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-yellow-500 px-4 py-2 shadow-inner transition duration-300"
      />
    </div>
    <!-- Country Code -->
    <div>
      <label for="id" class="block mb-1 text-sm font-semibold text-yellow-300">Country Id</label>
      <input
        id="id"
        formControlName="id"
        type="text"
        placeholder="Enter country id"
        class="w-full rounded-lg bg-gray-900 text-yellow-200 placeholder-yellow-500 border border-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-yellow-500 px-4 py-2 shadow-inner transition duration-300"
      />
    </div>
  </div>

  <!-- Buttons -->
  <div class="flex justify-end mt-6 space-x-4">
    <button
      (click)="onReset()"
      type="button"
      class="px-6 py-2 rounded-full text-sm font-bold text-yellow-300 border border-yellow-500 hover:bg-yellow-600 hover:text-black transition duration-300 shadow-md"
    >
      🔄 Reset
    </button>
    <button
      (click)="onSubmit()"
      type="submit"
      class="px-6 py-2 rounded-full text-sm font-bold text-black bg-gradient-to-r from-yellow-400 to-yellow-600 hover:from-yellow-500 hover:to-yellow-700 transition duration-300 shadow-lg"
    >
      ✅ Apply Filter
    </button>
  </div>
</div>
